type DistanceItem = {
  icon: React.ReactNode;
  label: string;
  abbreviation: string;
  distance: string;
  unit?: string;
};

interface DistanceTableProps {
  items: DistanceItem[];
}

export function DistanceTable({ items }: DistanceTableProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left text-sm">
        <thead>
          <tr>
            <th className="py-2 font-semibold">Entfernung zu</th>
            <th className="py-2 font-semibold">Abkürzung</th>
            <th className="py-2 font-semibold text-right">Entfernung</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, idx) => (
            <tr key={idx}>
              <td className="py-3 flex items-center gap-3">
                <span>{item.icon}</span>
                <span>{item.label}</span>
              </td>
              <td className="py-3">{item.abbreviation}</td>
              <td className="py-3 text-right">
                {item.distance}
                {item.unit ? `${item.unit}` : ""}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
